import BasePortalLib from "@products/base-portal-lib";
import "@products/base-portal-lib/dist/style.css";

export default defineNuxtPlugin({
	name: "base-portal-lib",
	order: 1030,
	setup: (nuxtApp) => {
		const config = useRuntimeConfig();

		nuxtApp.vueApp.use(BasePortalLib, {
			apiBaseUrl: config.public.API_URL,
			ssr: false,
		});
	},
});
